// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2UCrq","question":"Question_question__yBgZq","description":"Question_description__32ytT"};